





















































import { PropType } from 'vue';
// Components
import SummarySkeleton from '../skeletons/SummarySkeleton.vue';
import { Candidate } from '~/services/CandidateService';
import Vue from 'vue';

export default Vue.extend({
    name: 'Summary',
    components: { SummarySkeleton },
    props: {
        value: {
            type: Object as PropType<Candidate>,
            required: true,
        },
        validator: {
            type: Object,
            default: () => ({ isError: false, links: [] }),
        },
        isLoading: Boolean,
    },
    computed: {
        summary: {
            get: function(): string | null {
                return this.value.summary;
            },
            set: function(value: string): void {
                // @ts-ignore
                this.$emit('input', {
                    ...this.value,
                    summary: value,
                });
            },
        },
    },
    methods: {
        addLink(): void {
            const newLink = { name: '', value: '' };
            let links = this.value.links == null ? ([] as (typeof newLink)[]) : this.value.links;
            links.push(newLink);
            this.$emit('input', {
                ...this.value,
                links: links,
            });
        },
        removeLink(index: number): void {
            let links = this.value.links == null ? [] : this.value.links;
            links.splice(index, 1);
            this.$emit('input', {
                ...this.value,
                links: links,
            });
        },
    },
});
